import React from "react";
import { ArrowLeftOutlined, ArrowRightOutlined, WarningOutlined } from "@ant-design/icons";
import styles from "./SwmsWizard.module.css";

export default function SwmsWizardStep2({
  selectedCategories,
  selectedMethods,
  methodsByCategory,
  catLabels,
  showValidation,
  onToggleMethod,
  onContinue,
  onBack
}) {
  return (
    <div className={styles.stepBody}>
      {/* Selected categories summary */}
      <div className={styles.catSummaryRow}>
        {selectedCategories.map((catId) => {
          const catLabel = catLabels[catId];
          return (
            <span key={catId} className={styles.catSummaryTag}>
              {catLabel}
            </span>
          );
        })}
      </div>

      <h1 className={styles.stepTitle}>Step 2: Select Work Methods</h1>
      <p className={styles.stepSubtitle}>Select the specific work methods and hazard controls for your chosen categories.</p>

      <div className={styles.methodsContainer}>
        {selectedCategories.map((catId) => {
          const catLabel = catLabels[catId];
          const methods = methodsByCategory[catId] || [];
          return (
            <div key={catId} className={styles.methodSection}>
              <div className={styles.methodSectionHeader}>
                <span className={styles.methodSectionTag}>{catLabel}</span>
                <span className={styles.methodSectionHint}>Select applicable methods</span>
              </div>
              {methods.length === 0 ? (
                <div className={styles.noMethodsMsg}>
                  No methods available for this category.
                </div>
              ) : (
              <div className={styles.methodGrid}>
                {methods.map((method) => {
                  const methodId = Number(method.id);
                  const isMethodSelected = selectedMethods.includes(methodId);
                  const methodCardClass = isMethodSelected
                    ? `${styles.methodCard} ${styles.selected}`
                    : styles.methodCard;
                  return (
                    <div
                      key={method.id}
                      className={methodCardClass}
                      onClick={() => onToggleMethod(methodId)}
                    >
                      <input
                        type="checkbox"
                        className={styles.methodCheckbox}
                        checked={isMethodSelected}
                        onChange={() => onToggleMethod(methodId)}
                        onClick={(e) => e.stopPropagation()}
                      />
                      <span className={styles.methodLabel}>{method.method_name}</span>
                    </div>
                  );
                })}
              </div>
              )}
            </div>
          );
        })}
      </div>

      {showValidation && (
        <div className={styles.validationMsg}>
          <WarningOutlined />
          Please select at least one work method to continue.
        </div>
      )}

      <div className={styles.stepFooterBetween}>
        <button className={styles.backButton} onClick={onBack}>
          <ArrowLeftOutlined />
          Back to Categories
        </button>
        <button className={styles.continueButton} onClick={onContinue}>
          Continue to QLIs
          <ArrowRightOutlined />
        </button>
      </div>
    </div>
  );
}
